/* eslint-disable no-unused-expressions */
import Input from "./Input";
import TextArea from "./TextArea";
import SelectType from "./SelectType";
import AutoComplete from "./AutoComplete";
import AutoCompleteTags from "./AutoCompleteTags";
import FormDatePicker from "./FormDatePicker";
import FormFileUpload from "./FIleUpload/FileUpload";
import CheckBoxType from "./CheckBoxType";
import React from "react";
import MultipleTreeSelect from "./MultipleTreeSelect";

const FormController = (props) => {
  const { control, ...rest } = props;
  React.useEffect(() => {
    props.setParentState ? props.setParentState(props.formik.values) : "";
  }, [props.formik.values]);

  switch (control) {
    case "input": {
      return <Input type="number" {...rest} />;
    }
    case "number": {
      return <Input {...rest} />;
    }
    case "textarea": {
      return <TextArea {...rest} />;
    }
    case "select": {
      return <SelectType {...rest} />;
    }
    case "autocomplete": {
      return <AutoComplete {...rest} />;
    }
    case "tags": {
      return <AutoCompleteTags {...rest} />;
    }
    case "checkbox": {
      return <CheckBoxType {...rest} />;
    }
    case "file": {
      return <FormFileUpload {...rest} />;
    }
    case "date": {
      return <FormDatePicker {...rest} />;
    }
    case "selectWithCheckboxes": {
      return <MultipleTreeSelect {...rest} />;
    }
    default: {
      return <div></div>;
    }
  }
};

export default FormController;
